/**
 * Application Configuration Constants
 */

// API Configuration
export const API_CONFIG = {
BASE_URL: process.env.REACT_APP_API_BASE_URL || '',
    ENDPOINTS: {
        DOGS: '/api/dogs',
        OWNERS: '/api/owners',
        USERS: '/api/users',
        DAYCARE: {
            PACKAGES: '/api/daycare/packages',
            ACTIVE_PACKAGES: '/api/daycare/packages/active',
            VISITS: '/api/daycare/visits',
            VISITS_TODAY: '/api/daycare/visits/today'
        },
        HOTEL: '/api/hotel',
        AUTH: {
            LOGIN: '/api/auth/login',
            REFRESH: '/api/auth/refresh'
        }
    }
};

// UI Configuration
export const UI_CONFIG = {
    PAGINATION: {
        DOGS_PER_PAGE: 10,
        OWNERS_PER_PAGE: 12,
        BOOKINGS_PER_PAGE: 8
    },
    TIMEOUTS: {
        NOTIFICATION_DISMISS: 5000,
        API_REQUEST_TIMEOUT: 30000
    }
};

// User Roles — keep in sync with backend User.js model enum
export const USER_ROLES = {
    ADMIN: 'admin',
    RECEPTIONIST: 'receptionist',
    VET: 'vet',
};

// Form Validation
export const VALIDATION = {
    MIN_AGE: 0,
    MAX_AGE: 30,
    MIN_PASSWORD_LENGTH: 6,
    EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    PHONE_REGEX: /^\+?[\d\s\-\(\)]+$/
};
